var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('am-typography',{attrs:{"variant":"h5"}},[_vm._v(_vm._s(_vm.title))]),_c('am-spacing',{attrs:{"size":"2"}}),_c('am-tabs',{attrs:{"tabs":_vm.methods,"value":_vm.value || _vm.model,"minWidth":""},on:{"change":function($event){return _vm.$emit('change', $event)}}}),_c('am-spacing',{attrs:{"size":"1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }